import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import PageContainer from '../layouts/PageContainer';
import LearningPathDesignerScreen from './LearningPathDesignerScreen';

const TeacherLearningPathDesignerScreen: React.FC = () => {
  const { pathId } = useParams<{ pathId: string }>();
  const [searchParams] = useSearchParams();
  const cloneFromId = searchParams.get('cloneFrom');
  
  // Initialize mode based on pathId to prevent flashing
  const mode = pathId ? 'manage' : 'create';
  
  return (
    <PageContainer title={mode === 'create' ? 'Create Learning Path' : 'Edit Learning Path'} userRole="Teacher">
      <LearningPathDesignerScreen mode={mode} />
    </PageContainer>
  );
};

export default TeacherLearningPathDesignerScreen;
